import React from 'react';
import styled from 'styled-components';
import CategorySection from 'components/CategorySection/CategorySection';
import Slider from 'components/Slider/Slider';
import PromoBanner from 'components/PromoBanner/PromoBanner';
import ErrorPage from 'pages/ErrorPage/ErrorPage';
import { useServiceQuery, ServiceCategoryFragment } from 'generated/graphql';
import getCategoriesList from 'helpers/getCategoriesList';

const Wrapper = styled.div`
    padding-top: 110px;
    flex: 1;
`;

function MainPage() {
  const { data, error } = useServiceQuery();

  if (error) return <ErrorPage />;

  return (
    <Wrapper>
      <PromoBanner />
      {data && <Slider />}
      {data?.point?.service.categories && getCategoriesList(data?.point?.service.categories).map(
        (category: ServiceCategoryFragment, index) => {
          if (category) {
            const colored = index % 2 !== 0;
            return (
              <CategorySection
                key={category.id}
                category={category}
                authorized={!!data?.point?.verify}
                colored={colored}
              />
            );
          }

          return null;
        },
      )}
    </Wrapper>
  );
}

export default MainPage;
